<template lang="pug">
  .details-wrapper
    .name
      DBLabel(title="nome:", :body="user.name")
    .email
      DBLabel(title="e-mail:", :body="user.email")
    .permission
      DBLabel(title="permissões:", :body="user.roleGroup.name")
    .current-login-at
      DBLabel(title="ultimo acesso:", :body="user.currentLoginAt" :loading="loading")
    .group
      PMultiSelect(
        v-model="group"
        useCommon="companies"
        labelItem="name"
        :title="$wp('company')"
        :displayMode="true"
      )

    .actions-buttons
      PButton(
        color="success",
        size="md",
        @click="reactivateUser"
        :loading="loading"
        title="reativar"
        v-if="$hasPermission({module: 'user', action: 'post'}) && $store.state.common.users.deleted"
      )
        .icon-ptt-icons-check

      PButton(
        color="info",
        size="md",
        @click="editUser"
        :loading="loading"
        title="editar"
        v-if="$hasPermission({module: 'user', action: 'post'}) && !$store.state.common.users.deleted"
      )
        .icon-ptt-icons-lapis

      PButton(
        color="danger",
        size="md",
        @click="removeUser",
        :loading="removeLoading || loading"
        title="excluir"
        v-if="$hasPermission({module: 'user', action: 'delete'}) && !$store.state.common.users.deleted"
      )
        .icon-ptt-icons-excluir

</template>

<script>
import DBLabel from 'src/common/SmartTable/DBLabel'

export default {
  name: 'Details',
  components: {DBLabel},
  props: {
    user: {type: Object, required: true},
    loading: {type: Boolean, required: true}
  },
  data () {
    return {
      groupData: { selected: [] },
      removeLoading: false
    }
  },
  computed: {
    group: {
      set (val) { this.groupData = val },
      get () {
        return {
          selected: this.user.group
        }
      }
    }
  },
  methods: {
    async removeUser () {
      this.removeLoading = true
      try {
        await this.$API.user.remove({ id: this.user.id })
        this.$swal({
          type: 'success',
          title: 'Deletado com sucesso!',
          text: `Usuário ${this.user.name} foi removido com sucesso`
        })
      } catch (e) {
        const msg = e.data.error || 'Aconteceu um erro. Tente novamente.'
        this.$swal({
          type: 'error',
          title: 'Atenção',
          text: msg
        })
      }
      this.removeLoading = false
      this.$emit('reloadTable')
    },
    editUser () {
      this.$emit('editUser', this.user.id)
    },
    reactivateUser () {
      this.$emit('reactivateUser', this.user.id)
    }
  }
}
</script>

<style scoped lang="scss">
.details-wrapper {
  height: 100%;
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: .5fr .5fr .5fr 1fr;
  grid-column-gap: 20px;
  grid-template-areas:
    "name email"
    "group group"
    "permission current-login-at"
    ". buttons";

  .name { grid-area: name }
  .email { grid-area: email }
  .permission { grid-area: permission }
  .current-login-at { grid-area: current-login-at }
  .group { grid-area: group }
  .actions-buttons {
    grid-area: buttons;
    justify-self: right;
    align-self: end;
    display: grid;
    grid-auto-flow: column;
    grid-gap: 2px;
  }
}
</style>
